export default {
  title: 'Buy e-gift cards',
  subtitle:
    'Say it with a gift card from {{companyName}}. Perfect for birthdays, a thank you, or just because – redeemable flexibly for food & drinks.',
  header: {
    title: 'Gift Card',
    subtitle: 'Give joy',
  },
  buttons: {
    buy_now: 'Buy now',
  },
};
